import React from "react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";
import Onboarding from "../components/layout/Onboarding";

const ProtectedRoute = (props) => {
    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={loginRequest}
            errorComponent={Onboarding}
        >
            {props.children}
        </MsalAuthenticationTemplate>
    );
};

export default ProtectedRoute;
